import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Download, Check, Gift } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferBlock() {
  return <section id="oferta" className="py-24 bg-cream-dark/50 relative overflow-hidden" data-id="element-208">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-white/40 blur-3xl rounded-full pointer-events-none" data-id="element-209"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-210">
        <FadeIn data-id="element-211">
          <div className="bg-white rounded-[3rem] shadow-soft p-8 md:p-16 border border-white text-center" data-id="element-212">
            <h2 className="text-3xl md:text-5xl font-bold text-brown-dark mb-6" data-id="element-213">
              Recupera tus noches de sueño
            </h2>
            <p className="text-xl text-brown/80 font-serif mb-10" data-id="element-214">
              Transforma tus noches en solo 48 horas.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-215">
              <div className="text-center" data-id="element-216">
                <span className="text-sm font-bold text-accent uppercase tracking-wider mb-2 block" data-id="element-217">
                  Precio Especial
                </span>

                <div className="text-6xl md:text-7xl font-bold text-brown-dark font-serif" data-id="element-218">
                  $6,39
                </div>
              </div>

              <div className="text-left space-y-3" data-id="element-219">
                <div className="flex items-center gap-3" data-id="element-220">
                  <Check className="w-5 h-5 text-accent" data-id="element-221" />
                  <span className="text-brown-dark/80" data-id="element-222">
                    Acceso inmediato a la Guía
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-223">
                  <Check className="w-5 h-5 text-accent" data-id="element-224" />
                  <span className="text-brown-dark/80" data-id="element-225">
                    Todas las herramientas y plantillas
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-226">
                  <Check className="w-5 h-5 text-accent" data-id="element-227" />
                  <span className="text-brown-dark/80" data-id="element-228">
                    Bonus exclusivos incluidos
                  </span>
                </div>
              </div>
            </div>

            {/* Bonos Incluidos */}
            <div className="bg-cream/30 rounded-3xl p-8 mb-12 border-2 border-accent/20" data-id="element-229">
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-230">
                <Gift className="w-6 h-6 text-accent" data-id="element-231" />
                <h3 className="text-2xl font-bold text-brown-dark" data-id="element-232">
                  3 Bonos Gratis Incluidos
                </h3>
              </div>

              <div className="space-y-4 mb-6" data-id="element-233">
                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-234">
                  <div className="flex items-start justify-between gap-4" data-id="element-235">
                    <div className="flex items-start gap-3" data-id="element-236">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-237" />
                      <div data-id="element-238">
                        <h4 className="font-bold text-brown-dark" data-id="element-239">
                          Kit S.O.S. "Calma en 5 Minutos"
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-240">
                          Protocolo de emergencia nocturna
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-241">
                  <div className="flex items-start justify-between gap-4" data-id="element-242">
                    <div className="flex items-start gap-3" data-id="element-243">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-244" />
                      <div data-id="element-245">
                        <h4 className="font-bold text-brown-dark" data-id="element-246">
                          Guión Anti-Discusión Nocturna
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-247">
                          Para coordinación de pareja
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-248">
                  <div className="flex items-start justify-between gap-4" data-id="element-249">
                    <div className="flex items-start gap-3" data-id="element-250">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-251" />
                      <div data-id="element-252">
                        <h4 className="font-bold text-brown-dark" data-id="element-253">
                          Planner de Siestas "Aterrizaje Suave"
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-254">
                          Sistema flexible 0-12 meses
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center pt-4 border-t border-cream-dark" data-id="element-255">
                <p className="text-brown/70 mb-1" data-id="element-256">Valor real del paquete:</p>
                <div className="flex items-center justify-center gap-2" data-id="element-257">
                  <span className="text-xl line-through text-brown/40" data-id="element-258">
                    $47
                  </span>
                  <span className="text-base text-brown/70" data-id="element-259">hoy solo</span>
                  <span className="text-4xl font-bold text-accent" data-id="element-260">$6,39</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center" data-id="element-261">
              <div className="bg-accent/10 border border-accent/30 rounded-2xl px-6 py-3 mb-6" data-id="element-262">
                <p className="text-brown-dark font-bold text-sm md:text-base" data-id="element-263">
                  ⏳ Oferta especial disponible solo por tiempo limitado: Precio
                  actual: <span className="text-accent" data-id="element-264">$6.39</span>{' '}
                  <span className="line-through text-brown/50" data-id="element-265">
                    (valor real: $47)
                  </span>
                </p>
              </div>
              <Button href="https://tumundoequilibrado.com/cart/51096956993831:1" onClick={trackAddToCart} icon={<Download className="w-5 h-5" data-id="element-267" />} className="w-full md:w-auto md:px-12 py-5 text-xl mb-2" data-id="element-266">
                Descarga la Guía por solo $6.39
              </Button>
              <p className="text-base text-accent font-bold mb-2" data-id="element-268">
                y empieza hoy mismo
              </p>

              {/* Animated urgency message */}
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="my-4 inline-block bg-red-50 border-2 border-red-300 rounded-2xl px-5 py-3 shadow-sm" data-id="element-269">
                <p className="text-red-700 font-bold text-sm md:text-base flex items-center gap-2 justify-center flex-wrap" data-id="element-270">
                  <motion.span animate={{
                  rotate: [0, 15, -15, 0]
                }} transition={{
                  duration: 1.4,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="inline-block" data-id="element-271">
                    ⏳
                  </motion.span>
                  <span data-id="element-272">
                    Precio sube a{' '}
                    <span className="line-through opacity-70" data-id="element-273">$12.99</span> en
                    24 horas ·{' '}
                    <span className="underline" data-id="element-274">Solo quedan 3 copias</span>
                  </span>
                </p>
              </motion.div>

              <p className="text-sm text-brown/60 font-medium" data-id="element-275">
                Acceso inmediato | Incluye 3 bonos gratis | Resultados en las
                primeras 48 horas
              </p>
            </div>

            {/* 7-day Guarantee */}
            <div className="mt-10 pt-10 border-t border-cream-dark" data-id="element-276">
              <div className="bg-gradient-to-br from-cream/60 to-white rounded-3xl p-8 md:p-10 border-2 border-accent/30 max-w-2xl mx-auto" data-id="element-277">
                <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-278">
                  <div className="flex-shrink-0 w-20 h-20 rounded-full bg-accent/15 flex items-center justify-center text-4xl" data-id="element-279">
                    🛡️
                  </div>
                  <div className="flex-1" data-id="element-280">
                    <h3 className="text-2xl font-bold text-brown-dark mb-2" data-id="element-281">
                      Esto puede mejorar
                    </h3>
                    <p className="text-brown-dark/80 leading-relaxed mb-2" data-id="element-282">
                      Prueba el Método de Micropausas… y si no funciona en 48
                      horas, te devolvemos tu dinero.
                    </p>
                    <p className="text-accent font-bold" data-id="element-283">
                      Solo $6.39 en juego. No tienes nada que perder.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}